import store from '../store/store';
import jwt from 'jsonwebtoken';
import io from 'socket.io-client';
import service from './../services';

export default {
  oldValue: {},

  /**
   * Atualiza os contadores do Badge do Sidebar
   * O objeto de retorno deve conter propriedades com o mesmo valor de
   * 'keyBadge' no arquivo 'sidebarItems'
   *
   * Exemplo:
   * 'sidebarItems.js'
   * [
   *  {...},
   *  {..., hasBadge: true, keyBadge: 'cotacoes'},
   *  {..., hasBadge: true, keyBadge: 'vistoria'},
   *  {...}
   * ]
   *
   * O retorno deve ser:
   * {
   *  cotacoes: 999,
   *  vistoria: 999
   * }
   */

  // ------ A função espera esse formato de entrada de dados:
  //
  //   const dataM = {
  //   cotacoes: [
  //     { idRegional: 39, count: 14 },
  //     { idRegional: 169, count: 22 },
  //     { idRegional: 111, count: 7 },
  //     { idRegional: 106, count: 31 },
  //     { idRegional: 41, count: 10 },
  //     { idRegional: 269, count: 5 },
  //     { idRegional: 582, count: 17 },
  //     { idRegional: 76, count: 22 },
  //     { idRegional: 52, count: 8 },
  //   ],
  //   vistorias: [
  //     { idRegional: 39, count: 11 },
  //     { idRegional: 169, count: 19 },
  //     { idRegional: 111, count: 5 },
  //     { idRegional: 106, count: 26 },
  //     { idRegional: 41, count: 7 },
  //     { idRegional: 269, count: 3 },
  //     { idRegional: 582, count: 13 },
  //     { idRegional: 76, count: 20 },
  //     { idRegional: 52, count: 5 },
  //   ],
  //   eventos: [{ idRegional: 39, count: 180 }],
  // };

  // ------ A captura de regionais do token espera esse formato:
  //
  // const regionais = [
  //   {id_regional: 39},
  //   {id_regional: 169},
  //   {id_regional: 111},
  //   {id_regional: 106}
  // ];

  updateCountBadge(data) {
    const token = localStorage.getItem('user-token');
    const decoded = jwt.decode(token);
    const regionais = decoded.regionais;
    const totalCounts = {};

    this.oldValue = data;

    // Inicializa os valores totais como 0 para cada propriedade em "data" ("for in" itera objetos)
    for (const prop in data) {
      totalCounts[prop] = 0;
    }

    // Percorre cada propriedade em "data"
    for (const prop in data) {
      // Percorre dentro do array que é o valor da propriedade ("for of" itera arrays) e verifica a correspondência com "regionais"
      for (const item of data[prop]) {
        const matchingRegional = regionais.find(
          (regional) => regional.id_regional === item.idRegional,
        );
        // Caso haja correspondência, acumula o valor de count na propriedade
        if (matchingRegional) {
          totalCounts[prop] += item.count;
        }
      }
    }
    //Atualiza o estado global com o resultado da função
    store.dispatch('updateCountBadgeNewItems', totalCounts);
  },

  start() {
    const socket = io(process.env.VUE_APP_SERVER_SOCKET);
    socket.on('statusNotificationUpdateBadge', (res) => {
      this.updateCountBadge(res);
    });
  },

  getCountBadges() {
    try {
      const token = localStorage.getItem('user-token');
      const decoded = jwt.decode(token);
      if (decoded)
        service
          .getAll('status-notificacoes', null, 'get-count-badges')
          .then((res) => {
            if (res.data) {
              this.updateCountBadge(res.data);
            }
          })
          .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  },
};
